import { Axis } from './Axis.js';
import { AXIS_LABEL_HEIGHT } from './constants.js';
import { OrientedAxisProps } from './types.js';

/**
 * @internal
 */
export function AxisBottom({
  scale,
  label,
  height,
  ...restAxisProps
}: OrientedAxisProps) {
  // oxlint-disable-next-line typescript/no-non-null-assertion
  const labelOffset = height! - AXIS_LABEL_HEIGHT;

  return (
    <Axis
      orientation="bottom"
      scale={scale}
      height={height}
      label={label}
      labelOffset={labelOffset}
      {...restAxisProps}
    />
  );
}

AxisBottom['displayName'] = 'AxisBottom';
